import { graphql } from '@/gql';
import type { QaCalibrationsQuery, QaCalibrationsQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export type QaCalibrationRow = QaCalibrationsQuery['qaCalibrations']['rows'][number];

export const fetchQaCalibrations = async (variables: QaCalibrationsQueryVariables) => {
  const response = await queryExecute({
    variables,
    fetchPolicy: 'no-cache',
    query: graphql(`
      query QaCalibrations($filter: QaCalibrationFilterInput, $pagination: PaginationInputType) {
        qaCalibrations(filter: $filter, pagination: $pagination) {
          count
          rows {
            id
            callLogId
            submittedByUserId
            submittedByName
            operatorId
            operatorName
            source
            originalScore
            aiFeedback
            reviewerScore
            isAiCorrect
            aiMissedCriticalError
            createdAt
            canRaiseDispute
            canResolveDispute
            dispute {
              status
              reason
              disputedAt
              resolvedAt
              wasAiError
              resolutionNote
              resolvedByName
            }
          }
        }
      }
    `),
  });

  return response.data.qaCalibrations;
};
